module.exports = __webpack_public_path__ + "static/media/Value.c7c6a758.png";